import { Component, OnInit } from "@angular/core";
import { NgForm, FormGroup, FormControl, Validators } from "@angular/forms";
import { BookServiceService } from "src/app/services/book-service.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-add-post",
  templateUrl: "./add-post.component.html",
  styleUrls: ["./add-post.component.scss"]
})
export class AddPostComponent implements OnInit {
  constructor(private bookSer: BookServiceService, private router: Router) {}
  validatingForm: FormGroup;
  isLoading = false;

  ngOnInit() {
    this.validatingForm = new FormGroup({
      title: new FormControl("", Validators.required),
      description: new FormControl("", [
        Validators.required,
        Validators.minLength(10)
      ]),
      image: new FormControl("", [
        Validators.required,
        Validators.minLength(10)
      ])
    });
  }

  on(form: any) {
    this.isLoading = true;
    const v = form.value;
    const title = v.title;
    const description = v.description;
    const image = v.image;
    this.bookSer
      .AddPost({ title, description, image })
      .catch(err => err)
      .then(() => {
        this.isLoading = true;
        form.reset();
      })
      .finally(() => {
        this.isLoading = false;
        this.router.navigate(["admin/posts"]);
      });
    this.isLoading = false;
  }
}
